export const formatTelegramDate = (dateString, locale = navigator.language) => {
  const date = new Date(dateString)
  const now = new Date()

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const startOfYesterday = new Date(startOfToday)
  startOfYesterday.setDate(startOfYesterday.getDate() - 1)

  const isToday = date >= startOfToday
  const isYesterday = date >= startOfYesterday && date < startOfToday

  if (isToday) {
    return new Intl.DateTimeFormat(locale, {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date)
  }

  if (isYesterday) {
    const yesterdayTranslations = {
      ru: "Вчера",
      en: "Yesterday",
      de: "Gestern",
      fr: "Hier",
      ro: "Ieri",
    }

    const lang = locale.split("-")[0]
    return yesterdayTranslations[lang] || yesterdayTranslations.en
  }

  if (date.getFullYear() === now.getFullYear()) {
    return new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "short",
    }).format(date)
  }

  return new Intl.DateTimeFormat(locale).format(date)
}

export const formatDateDivider = (dateStr, locale) => {
  const date = new Date(dateStr)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  const isSameDay = (a, b) =>
    a.getDate() === b.getDate() &&
    a.getMonth() === b.getMonth() &&
    a.getFullYear() === b.getFullYear()

  if (isSameDay(date, today)) return "Сьогодні"
  if (isSameDay(date, yesterday)) return "Вчора"

  return date.toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: date.getFullYear() !== today.getFullYear() ? "numeric" : undefined,
  })
}
